<template>
  <div id="app">
    <!-- 全局中文语言包：日期面板、分页、空状态等统一走 zhCN -->
    <!-- <a-config-provider :locale="zhCN">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </a-config-provider> -->

    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </div>

  <!-- <div @click="cut"
    style="width: 120px;  background: #3496ff; opacity: 0.5; position: absolute; right: 2%; top: 12%; border-radius: 50%; display: flex; align-items: center; justify-content: center; z-index: 999; cursor: pointer;">
    <a-select v-model:value="currentLang" style="width: 120px" @change="handleChange">
      <a-select-option v-for="(item, itemIndex) in language" :key="itemIndex" :value="item.value">
        {{ item.text }}
      </a-select-option>
    </a-select>
  </div> -->
</template>

<script>
export default {
  name: 'App'
}
</script>
<script setup>
import { onMounted, onBeforeUnmount, } from 'vue'
import { setRemUnit } from '@/utils/general'
// import zhCN from 'ant-design-vue/es/locale/zh_CN'

onMounted(() => {

  setRemUnit()
  window.addEventListener('resize', setRemUnit)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', setRemUnit)
})
</script>

<style>
#app {
  height: 100vh;
  /* width: 100vw; */
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  width: 100%;
}

:where(.css-dev-only-do-not-override-1p3hq3p).ant-table-wrapper .ant-table-pagination-right {
  justify-content: center !important;
}

.no-data {
  background: #fff;
  padding: 48px;
  border-radius: 8px;
  text-align: center;
}

.animation-zyd {
  /* animation: animationzyd 3s linear infinite; */
  transform-origin: 50% 95%;
}

ul,
li,
ol {
  list-style: none;
  margin: 0;
  padding: 0;
}

@keyframes animationzyd {

  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(-2deg);
  }

  75% {
    transform: rotate(2deg);
  }

  100% {
    transform: rotate(0deg);
  }

}
</style>